function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { uuid } from 'uuidv4';

var Photo = /*#__PURE__*/function () {
  _createClass(Photo, null, [{
    key: "getImageData",
    value: function getImageData(storage, id) {
      return storage.getById('photo', id, ['image_data']).then(function (results) {
        return results[0].image_data;
      });
    }
  }, {
    key: "save",
    value: function save(storage, photo) {
      return storage.addOrUpdate('photo', photo.id, ['parent', 'image_data'], [photo.parent, photo.imageData]);
    }
  }, {
    key: "delete",
    value: function _delete(storage, id) {
      return storage.deleteById('photo', id);
    }
  }]);

  function Photo(props) {
    var _this = this;

    _classCallCheck(this, Photo);

    _defineProperty(this, "data", function (storage) {
      return Photo.getImageData(storage, _this.id);
    });

    _defineProperty(this, "save", function (storage) {
      return Photo.save(storage, _this);
    });

    _defineProperty(this, "delete", function (storage) {
      return Photo.save(storage, _this.id);
    });

    this.id = uuid();
    this.parent = undefined;
    this.imageData = undefined;

    _extends(this, props);
  }

  return Photo;
}();

export default Photo;